import 'jquery';
import 'popper.js';
import 'bootstrap';

import { environment } from '../environments/environment';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { LayoutComponent } from './components/layout/layout.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LoginComponent } from './login/login.component';
import { LocalParserFormatter } from 'core-lib';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { AlertService, GuidService, AuthorizeService, BackendService, FormValidationService, CoreLibModule, GooglePlacesService } from 'core-lib';
import { ApplicationComponent } from './application/application.component';
import { ApplicationConfirmComponent } from './application-confirm/application-confirm.component';
import { ApplicationService } from './services/application.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthorizedGuardService } from './services/authorized-guard.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ValidateEmailComponent } from './validate-email/validate-email.component';
import { TransactionsListComponent } from './transactions-list/transactions-list.component';
import { VehiclesListComponent } from './vehicles-list/vehicles-list.component';
import { BillingListComponent } from './billing-list/billing-list.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { HelpComponent } from './help/help.component';
import { YesCancelModalComponent } from './modals/yes-cancel-modal/yes-cancel-modal.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { WaterUsageComponent } from './water-usage/water-usage.component';
import { WaterUsageBulkComponent } from './water-usage-bulk/water-usage-bulk.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PermitRenewComponent } from './permit-renew/permit-renew.component';
import { VehiclesAddComponent } from './vehicles-add/vehicles-add.component';
import { ApplicationVideoComponent } from './application-video/application-video.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { LoggerLocationModalComponent } from './modals/logger-location-modal/logger-location-modal.component';
import { TermsAndConditionsModalComponent } from './modals/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { LandingComponent } from './landing/landing.component';
import { LandingFooterComponent } from './landing-footer/landing-footer.component';
import { LandingHeaderComponent } from './landing-header/landing-header.component';
import { LandingMenuComponent } from './landing-menu/landing-menu.component';
import { BackflowTooltipModalComponent } from './modals/backflow-tooltip-modal/backflow-tooltip-modal.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { EmsTooltipModalComponent } from './modals/ems-tooltip-modal/ems-tooltip-modal.component';
import { VehicleExistsWarningModalComponent } from './modals/vehicle-exists-warning-modal/vehicle-exists-warning-modal.component';
import { UserAccountListComponent } from './user-account-list/user-account-list.component';
import { UserAccountDetailsComponent } from './user-account-details/user-account-details.component';
import { SetPasswordModalComponent } from './modals/set-password-modal/set-password-modal.component';


const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'landing', component: LandingComponent },
  { path: 'application', component: ApplicationComponent },
  { path: 'application-video', component: ApplicationVideoComponent },
  { path: 'application-confirm/:id', component: ApplicationConfirmComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:id', component: ResetPasswordComponent },
  { path: 'validate-email/:id', component: ValidateEmailComponent },
  {
    path: 'app', component: LayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthorizedGuardService] },
      { path: 'transactions', component: TransactionsListComponent, canActivate: [AuthorizedGuardService] },
      { path: 'vehicles', component: VehiclesListComponent, canActivate: [AuthorizedGuardService] },
      { path: 'billing', component: BillingListComponent, canActivate: [AuthorizedGuardService] },
      { path: 'account', component: AccountDetailsComponent, canActivate: [AuthorizedGuardService] },
      { path: 'user-accounts', component: UserAccountListComponent, canActivate: [AuthorizedGuardService] },
      { path: 'user-accounts/:id', component: UserAccountDetailsComponent, canActivate: [AuthorizedGuardService] },
      { path: 'water-usage', component: WaterUsageComponent, canActivate: [AuthorizedGuardService] },
      { path: 'water-usage/:id', component: WaterUsageComponent, canActivate: [AuthorizedGuardService] },
      { path: 'water-usage-bulk', component: WaterUsageBulkComponent, canActivate: [AuthorizedGuardService] },
      { path: 'water-usage-bulk/:id', component: WaterUsageBulkComponent, canActivate: [AuthorizedGuardService] },
      { path: 'help', component: HelpComponent, canActivate: [AuthorizedGuardService] },
      { path: 'contactus', component: ContactUsComponent, canActivate: [AuthorizedGuardService] },
      { path: 'renew-permit', component: PermitRenewComponent, canActivate: [AuthorizedGuardService] },
      { path: 'vehicle-add', component: VehiclesAddComponent, canActivate: [AuthorizedGuardService] },
      { path: 'vehicle-edit/:id', component: VehiclesAddComponent, canActivate: [AuthorizedGuardService] },
      { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthorizedGuardService] },
    ]
  },
  { path: '', component: LandingComponent },
  { path: '**', component: LoginComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    NavbarComponent,
    LoginComponent,
    ApplicationComponent,
    ApplicationConfirmComponent,
    DashboardComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ValidateEmailComponent,
    TransactionsListComponent,
    VehiclesListComponent,
    BillingListComponent,
    AccountDetailsComponent,
    UserAccountListComponent,
    UserAccountDetailsComponent,
    HelpComponent,
    YesCancelModalComponent,
    TermsAndConditionsComponent,
    VehicleDetailsComponent,
    WaterUsageComponent,
    WaterUsageBulkComponent,
    ChangePasswordComponent,
    TopbarComponent,
    PermitRenewComponent,
    VehiclesAddComponent,
    ApplicationVideoComponent,
    FileUploadComponent,
    LoggerLocationModalComponent,
    TermsAndConditionsModalComponent,
    LandingComponent,
    LandingFooterComponent,
    LandingHeaderComponent,
    LandingMenuComponent,
    BackflowTooltipModalComponent,
    ContactUsComponent,
    EmsTooltipModalComponent,
    VehicleExistsWarningModalComponent,
    UserAccountListComponent,
    UserAccountDetailsComponent,
    SetPasswordModalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    CoreLibModule.forRoot(environment),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false, relativeLinkResolution: 'legacy' } // <-- debugging purposes only
 // <-- debugging purposes only
    ),
    HttpClientModule,
    NgbDatepickerModule,
    GooglePlaceModule
  ],
  providers: [
    AlertService,
    GuidService,
    AuthorizeService,
    BackendService,
    GooglePlacesService,
    FormValidationService,
    LocalParserFormatter,
    ApplicationService,
    { provide: NgbDateParserFormatter, useClass: LocalParserFormatter },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
